export const getFilters = '/api/v1/catalogue/filters';
export const findCoursesByCriteria = page => `/api/v1/catalogue?page=${page}`;
